import { React, useState, useContext, useEffect } from "react";
import { Grid, Tooltip, IconButton, Container } from "@material-ui/core";

import {
  EditOutlined,
  DeleteOutlined,
  Add,
  Visibility,
} from "@material-ui/icons/";

import ModalEmissaoParamProduto from "./ModalEmissaoParamProdutos";
import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Fieldset from "../../../../components/basics/Fieldset";
import TableDefault from "../../../../components/grid/TableDefault";

import { Header, Body, BodyItens } from "../styles/Emissao";

import useEmissaoController from "../controllers/EmissaoController";

import { EmissaoContext } from "../contexts/EmissaoContext";
import MaskService from "../../../../utils/mask/maskService";

const AccordionEmissaoItens = ({ ...props }) => {
  const {
    nfeError,
    itensTable,
    setItensTable,
    itensTotalValueIcms,
    setItensTotalValueIcms,
    itensTotalBaseIcms,
    setItensTotalBaseIcms,
    itensTotalIcmsFcp,
    setItensTotalIcmsFcp,
    itensTotalIcmsDes,
    setItensTotalIcmsDes,
    itensTotalValueSt,
    setItensTotalValueSt,
    itensTotalBaseSt,
    setItensTotalBaseSt,
    itensTotalStFcp,
    setItensTotalStFcp,
    itensTotalStWithheld,
    setItensTotalStWithheld,
    itensTotalValueIpi,
    setItensTotalValueIpi,
    itensTotalIpiReturned,
    setItensTotalIpiReturned,
    itensTotalValuePis,
    setItensTotalValuePis,
    itensTotalValueCofins,
    setItensTotalValueCofins,
    itensTotalValueCustoms,
    setItensTotalValueCustoms,
    itensTotalValueII,
    setItensTotalValueII,
    itensTotalFreight,
    setItensTotalFreight,
    itensTotalSafe,
    setItensTotalSafe,
    itensTotalOthers,
    setItensTotalOthers,
    itensTotalDiscount,
    setItensTotalDiscount,
    itensTotal,
    itensTotalProductValue,
    itensTotalNfe,
    nfeFinancialIssue,
    visualizationOnly,
    saveBlocked,
  } = useContext(EmissaoContext);

  const {
    handleConfirmActionItem,
    handleCalcItensTable,
    handleTotalsRecalculation,
    getCodeBarProduct,
    getDescriptionProduct,
  } = useEmissaoController();

  const [modalProdutosOpen, setModalProdutosOpen] = useState(false);
  const [index, setIndex] = useState(null);

  const handleIndexOpenModal = (value) => {
    setIndex(value);
    setModalProdutosOpen(true);
  };

  const handleChangeDiscountTotal = (value) => {
    let valueToSet = MaskService.removeMaskDecimal(
      MaskService.toMask("decimal", value || "0,00", 2),
      2
    );

    const maxValue = MaskService.removeMaskDecimal(itensTotalProductValue, 2);

    if (valueToSet >= maxValue) {
      valueToSet = maxValue;
    }

    setItensTotalDiscount(
      MaskService.toMask("decimal", valueToSet.toFixed(2), 2)
    );
  };

  useEffect(() => {
    handleCalcItensTable();
    // eslint-disable-next-line
  }, [itensTable]);

  const columnsTableItens = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip
              title={
                !visualizationOnly && !saveBlocked ? "Editar" : "Visualizar"
              }
            >
              <IconButton onClick={() => handleIndexOpenModal(value.index)}>
                {!visualizationOnly && !saveBlocked ? (
                  <EditOutlined />
                ) : (
                  <Visibility />
                )}
              </IconButton>
            </Tooltip>
            {!visualizationOnly && !saveBlocked && (
              <Tooltip title="Deletar">
                <IconButton
                  onClick={() => {
                    handleConfirmActionItem(
                      value.index,
                      itensTable,
                      setItensTable
                    );
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
      align: "center",
      style: { minWidth: 120 },
    },
    {
      label: "Código",
      align: "center",
      format: (value) => {
        return <>{getCodeBarProduct(value, "AccordionEmissaoItens")}</>;
      },
    },
    {
      label: "Descrição",
      align: "center",
      format: (value) => {
        return <>{getDescriptionProduct(value, "AccordionEmissaoItens")}</>;
      },
      style: { minWidth: 650 },
    },
    {
      label: "CFOP",
      id: "prodCfop",
      align: "center",
      style: { minWidth: 100 },
    },
    {
      label: "CSOSN",
      align: "center",
      style: { minWidth: 100 },
      format: (value) => {
        return <>{value.prodIcmsSituacao?.value}</>;
      },
    },
    {
      label: "Peso Un",
      id: "prodUnPeso",
      align: "center",
      style: { minWidth: 100 },
    },
    {
      label: "UN",
      align: "center",
      format: (value) => {
        return <>{value.prodUnSales || value.prodUn}</>;
      },
    },
    {
      label: "Qtde",
      id: "prodQuantidade",
      align: "center",
    },
    {
      label: "Vlr Unit",
      id: "prodValorUnitario",
      style: { minWidth: 100 },
      align: "center",
      format: (value) => `R$ ${value.prodValorUnitario}`,
    },
    {
      label: "Valor Total",
      id: "prodValorTotal",
      align: "center",
      style: { minWidth: 120 },
      format: (value) => `R$ ${value.prodValorTotal}`,
    },
    {
      label: "Desc",
      id: "prodDesconto",
      align: "center",
      style: { minWidth: 100 },
      format: (value) => `R$ ${value.prodDesconto}`,
    },
    {
      label: "Acresc",
      align: "center",
      style: { minWidth: 100 },
      format: (value) => {
        const total =
          MaskService.removeMaskDecimal(value?.prodFrete || "0,00") +
          MaskService.removeMaskDecimal(value?.prodSeguro || "0,00") +
          MaskService.removeMaskDecimal(value?.prodDespesas || "0,00");
        return `R$ ${MaskService.toMask("decimal", total.toFixed(2))}`;
      },
    },
  ];

  return (
    <>
      {modalProdutosOpen && (
        <ModalEmissaoParamProduto
          modalProdutosOpen={modalProdutosOpen}
          setModalProdutosOpen={setModalProdutosOpen}
          index={index}
        />
      )}
      <Fieldset
        titulo={
          <Header>
            <Grid container spacing={2}>
              <Grid item sm>
                <Chip
                  bgcolor={
                    nfeError.accordions && nfeError.accordions.includes("itens")
                      ? "red"
                      : ""
                  }
                  textcolor={
                    nfeError.accordions && nfeError.accordions.includes("itens")
                      ? "white"
                      : ""
                  }
                  label="ITENS / PRODUTOS"
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Valor Total de Produtos"
                  variant="filled"
                  size="small"
                  mask="decimal"
                  value={itensTotalProductValue}
                  error={nfeError.itensTotalProductValue ? true : false}
                  helperText={nfeError.itensTotalProductValue || ""}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Total da Nota Fiscal"
                  variant="filled"
                  mask="decimal"
                  size="small"
                  value={itensTotalNfe}
                  error={nfeError.itensTotalNfe ? true : false}
                  helperText={nfeError.itensTotalNfe || ""}
                  disabled
                />
              </Grid>
              <Grid item>
                <Btn
                  label="Adicionar Produto"
                  onFocus={(event) => event.stopPropagation()}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleIndexOpenModal(null);
                  }}
                  startIcon={<Add />}
                  disabled={visualizationOnly}
                />
              </Grid>
            </Grid>
          </Header>
        }
        bgcolor="white"
        textcolor="white"
        defaultExpanded={true}
        accordion
      >
        <Container maxWidth="xl">
          <BodyItens>
            <Grid item lg={12}>
              <TableDefault
                selectable={false}
                columns={columnsTableItens}
                tableTitle=""
                values={itensTable}
              />
            </Grid>
            <Grid item lg={12}>
              <Fieldset
                titulo={
                  <Grid container spacing={2}>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        label="Total de Itens"
                        variant="filled"
                        mask="integer"
                        size="small"
                        value={itensTotal}
                        error={nfeError.itensTotal ? true : false}
                        helperText={nfeError.itensTotal || ""}
                        disabled
                      />
                    </Grid>
                    <Grid item lg={5} sm={5}>
                      <TextField
                        label="Valor Total de Produtos"
                        variant="filled"
                        size="small"
                        mask="decimal"
                        value={itensTotalProductValue}
                        error={nfeError.itensTotalProductValue ? true : false}
                        helperText={nfeError.itensTotalProductValue || ""}
                        disabled
                      />
                    </Grid>
                    <Grid item lg={5} sm={4}>
                      <TextField
                        label="Total da Nota Fiscal"
                        variant="filled"
                        mask="decimal"
                        size="small"
                        value={itensTotalNfe}
                        error={nfeError.itensTotalNfe ? true : false}
                        helperText={nfeError.itensTotalNfe || ""}
                        disabled
                      />
                    </Grid>
                  </Grid>
                }
                bgcolor="white"
                textcolor="black"
                accordion
                defaultExpanded={false}
              >
                <Body>
                  <Grid container spacing={4}>
                    <Grid item sm={6}>
                      <Card label="ICMS" line="left" lineColor="primary">
                        <Grid container spacing={3}>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalValueIcms}
                              setValue={setItensTotalValueIcms}
                              error={
                                nfeError.itensTotalValueIcms ? true : false
                              }
                              helperText={nfeError.itensTotalValueIcms || ""}
                              label="Valor de ICMS"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalBaseIcms}
                              setValue={setItensTotalBaseIcms}
                              error={nfeError.itensTotalBaseIcms ? true : false}
                              helperText={nfeError.itensTotalBaseIcms || ""}
                              label="Base de ICMS"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalIcmsFcp}
                              setValue={setItensTotalIcmsFcp}
                              label="ICMS FCP"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalIcmsDes}
                              setValue={setItensTotalIcmsDes}
                              label="ICMS Desonerado"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item sm={6}>
                      <Card label="ICMS ST" line="left" lineColor="primary">
                        <Grid container spacing={3}>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalValueSt}
                              setValue={setItensTotalValueSt}
                              error={nfeError.itensTotalValueSt ? true : false}
                              helperText={nfeError.itensTotalValueSt || ""}
                              label="Valor ICMS ST"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalBaseSt}
                              setValue={setItensTotalBaseSt}
                              error={nfeError.itensTotalBaseSt ? true : false}
                              helperText={nfeError.itensTotalBaseSt || ""}
                              label="Base ICMS ST"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalStFcp}
                              setValue={setItensTotalStFcp}
                              label="ICMS ST FCP"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalStWithheld}
                              setValue={setItensTotalStWithheld}
                              label="ICMS ST FCP Retido"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item sm={6}>
                      <Card label="IPI" line="left" lineColor="primary">
                        <Grid container spacing={3}>
                          <Grid item lg={12} sm={6}>
                            <TextField
                              value={itensTotalValueIpi}
                              setValue={setItensTotalValueIpi}
                              label="Valor IPI"
                              size="small"
                              mask="decimal"
                              error={nfeError.itensTotalValueIpi ? true : false}
                              helperText={nfeError.itensTotalValueIpi || ""}
                              disabled
                            />
                          </Grid>
                          <Grid item lg={12} sm={6}>
                            <TextField
                              value={itensTotalIpiReturned}
                              setValue={setItensTotalIpiReturned}
                              label="Valor IPI Devolvido"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item sm={6}>
                      <Card
                        label="PIS e COFINS"
                        line="left"
                        lineColor="primary"
                      >
                        <Grid container spacing={3}>
                          <Grid item lg={12} sm={6}>
                            <TextField
                              value={itensTotalValuePis}
                              setValue={setItensTotalValuePis}
                              label="Valor PIS"
                              error={nfeError.itensTotalValuePis ? true : false}
                              helperText={nfeError.itensTotalValuePis || ""}
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item lg={12} sm={6}>
                            <TextField
                              value={itensTotalValueCofins}
                              setValue={setItensTotalValueCofins}
                              error={
                                nfeError.itensTotalValueCofins ? true : false
                              }
                              helperText={nfeError.itensTotalValueCofins || ""}
                              label="Valor COFINS"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item sm={6}>
                      <Card label="II" line="left" lineColor="primary">
                        <Grid container spacing={3}>
                          <Grid item sm={12}>
                            <TextField
                              value={itensTotalValueCustoms}
                              setValue={setItensTotalValueCustoms}
                              label="Valor Aduaneiro"
                              size="small"
                              mask="decimal"
                              disabled
                            />
                          </Grid>
                          <Grid item sm={12}>
                            <TextField
                              value={itensTotalValueII}
                              setValue={setItensTotalValueII}
                              error={nfeError.itensTotalValueII ? true : false}
                              helperText={nfeError.itensTotalValueII || ""}
                              label="Valor II"
                              mask="decimal"
                              size="small"
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item sm={6}>
                      <Card label="OUTROS" line="left" lineColor="primary">
                        <Grid container spacing={3}>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalFreight}
                              setValue={setItensTotalFreight}
                              label="Total Frete"
                              size="small"
                              mask="decimal"
                              disabled={!itensTable.length || visualizationOnly}
                              onBlur={handleTotalsRecalculation}
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalSafe}
                              setValue={setItensTotalSafe}
                              label="Total Seguro"
                              mask="decimal"
                              size="small"
                              disabled={!itensTable.length || visualizationOnly}
                              onBlur={handleTotalsRecalculation}
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalOthers}
                              setValue={setItensTotalOthers}
                              error={nfeError.itensTotalOthers ? true : false}
                              helperText={nfeError.itensTotalOthers || ""}
                              label="Total Out. Despesas"
                              size="small"
                              mask="decimal"
                              disabled={!itensTable.length || visualizationOnly}
                              onBlur={handleTotalsRecalculation}
                            />
                          </Grid>
                          <Grid item lg={6} sm={6}>
                            <TextField
                              value={itensTotalDiscount}
                              setValue={setItensTotalDiscount}
                              label="Total Desconto"
                              size="small"
                              disabled={
                                !itensTable.length ||
                                nfeFinancialIssue === "VENDA" ||
                                visualizationOnly
                              }
                              onBlur={handleTotalsRecalculation}
                              onChange={({ target: { value } }) => {
                                handleChangeDiscountTotal(value);
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Body>
              </Fieldset>
            </Grid>
          </BodyItens>
        </Container>
      </Fieldset>
    </>
  );
};

export default AccordionEmissaoItens;
